import { pxToRem } from 'utils/scss';

export const columnDetails = [
  {
    accessor: 'checkbox',
    contentType: 'checkBox',
    position: 'center',
    width: pxToRem('24px'),
    size: pxToRem('24px')
  },
  {
    accessor: 'email',
    contentType: 'text',
    headerType: 'text',
    position: 'left',
    width: '2.5fr'
  },
  {
    accessor: 'role',
    headerType: 'text',
    contentType: 'text',
    position: 'left',
    width: '2fr',
    translated: true
  },
  {
    accessor: 'companyDesc',
    headerType: 'text',
    contentType: 'text',
    position: 'left'
  },
  {
    accessor: 'updatedOn',
    headerType: 'text',
    contentType: 'text',
    position: 'left',
    width: '1.5fr',
    sortable: true
  },
  {
    accessor: 'status',
    headerType: 'text',
    contentType: 'status',
    position: 'center',
    width: '1.5fr',
    translated: true
  },
  {
    accessor: 'action_progress',
    contentType: 'progress_icon',
    headerType: 'text',
    position: 'center',
    width: '1.1fr'
  },
  {
    accessor: 'action',
    contentType: 'delete_icon',
    position: 'center'
  }
];
